import "core-js/modules/es7.object.get-own-property-descriptors.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.slice.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.string.includes.js";
import "regenerator-runtime/runtime.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.regexp.to-string.js";
import "core-js/modules/es6.date.to-string.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.function.name.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { mapGetters, mapActions, mapMutations } from 'vuex';
import jwtDecode from 'jwt-decode';
import aa from 'search-insights';
import { NEW_RELIC_SCRIPT } from '@/store/modules/script/types';
import TheFooter from '~/components/specific/TheFooter/TheFooter.vue';
import { ABTASTY_URL, GOOGLE_SITE_VERIFICATION, NORTON_SAFEWEB_SITE_VERIFICATION } from '~/const/3rd';
import { FAST_TIMER } from '~/const/timers';
import parseHash, { refreshTokenIfNecessary } from '~/helpers/auth-helpers';
import { isValidToken } from '~/helpers/connection-helper';
import SEARCH_PROVIDER from '~/helpers/search-data-helpers';
import Notifications from '~/mixins/Notifications';
import ValidateMarketToken from '~/mixins/ValidateMarketToken';
import trackEvent from '~/modules/trackEvent';
import datadome from '~/plugins/datadome';
var MainHeader = function MainHeader() {
  return import('~/components/specific/MainHeader/MainHeader/index.vue');
};
var MdmLayer = function MdmLayer() {
  return import('~/components/atoms/Global/MdmLayer.vue');
};
var MdmBackToTop = function MdmBackToTop() {
  return import('~/components/atoms/Global/MdmBackToTop.vue');
};
var SkipLinks = function SkipLinks() {
  return import('~/components/molecules/Global/Skiplinks.vue');
};
var NotificationBanner = function NotificationBanner() {
  return import('~/components/organisms/Global/NotificationBanner.vue');
};
export default {
  name: 'Default',
  components: {
    MainHeader: MainHeader,
    TheFooter: TheFooter,
    MdmBackToTop: MdmBackToTop,
    SkipLinks: SkipLinks,
    NotificationBanner: NotificationBanner
  },
  mixins: [Notifications, ValidateMarketToken],
  data: function data() {
    return {
      mdmLayer: null,
      tp: true,
      tcVars: {},
      ready: true,
      hashFirstCat: null,
      routesOnNavModifications: ['market-language-c-alias', 'market-language-p-alias']
    };
  },
  head: function head() {
    return {
      __dangerouslyDisableSanitizers: ['script'],
      script: [this.newRelicScript, this.tcVarsScript, this.tagCo, this.safariFix, this.searchInsights, this.datadomeJS],
      meta: [{
        hid: 'robots',
        name: 'robots',
        content: 'noodp'
      }, {
        name: 'google-site-verification',
        content: GOOGLE_SITE_VERIFICATION
      }, {
        name: 'norton-safeweb-site-verification',
        content: NORTON_SAFEWEB_SITE_VERIFICATION
      }, {
        name: 'theme-color',
        content: '#3C3C3B'
      }, this.containsQuery],
      link: _toConsumableArray(this.preconnectDomains),
      htmlAttrs: {
        lang: this.locale.language
      }
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters({
    user: 'user/me',
    locale: 'i18n/locale',
    tracking: 'sharedEnv/tracking',
    notification: 'notification/notification'
  })), {}, {
    page: function page() {
      return this.handleRouteOnChange(this.$route.name);
    },
    containsQuery: function containsQuery() {
      return {};
    },
    preconnectDomains: function preconnectDomains() {
      return [{
        rel: 'preconnect',
        href: 'https://fonts.gstatic.com/',
        crossorigin: true
      }, {
        rel: 'dns-prefetch',
        href: '//fonts.googleapis.com'
      }];
    },
    newRelicScript: function newRelicScript() {
      var newRelicScript = this.$store.getters[NEW_RELIC_SCRIPT];
      if (newRelicScript === '' || !newRelicScript) {
        return false;
      }
      return {
        innerHTML: newRelicScript,
        body: false,
        head: true
      };
    },
    datadomeJS: function datadomeJS() {
      return {
        innerHTML: datadome(),
        body: true,
        defer: true
      };
    },
    tcVarsScript: function tcVarsScript() {
      if (process.client || !Object.keys(this.tcVars).length) {
        return false;
      }
      return {
        innerHTML: "window.tc_vars = ".concat(JSON.stringify(this.tcVars), ";"),
        body: true
      };
    },
    searchInsights: function searchInsights() {
      if (!process.client && SEARCH_PROVIDER(this) !== 'algolia') {
        return false;
      }
      var _this$$store$state$sh = this.$store.state.sharedEnv.payload.algolia,
        algoliaApplicationID = _this$$store$state$sh.applicationId,
        algoliaApiKey = _this$$store$state$sh.apiKey;
      var userToken = this.$cookies.get('_ALGOLIA');
      aa('init', {
        appId: algoliaApplicationID,
        apiKey: algoliaApiKey
      });
      if (userToken) {
        aa('setUserToken', userToken);
      }
      return {
        body: true,
        async: true
      };
    },
    tagCo: function tagCo() {
      if (!process.server || this.tp === false) {
        return false;
      }
      return {
        innerHTML: "\n          window.addEventListener(\"load\", function(){\n            var script = document.createElement('script');\n            var s = document.getElementsByTagName('script')[0];\n            script.type = 'text/javascript';\n            script.async = true;\n            window.tc_vars = window.tc_vars || {};\n            window.tc_vars.env_country = window.__NUXT__.state.i18n.currentLocale.market;\n            window.tc_vars.env_language = window.__NUXT__.state.i18n.currentLocale.language;\n            window.tc_vars.env_template = '".concat(this.$route.name, "' == 'market-language-c-alias' ? 'liste produits' :  window.tc_vars.env_template;\n            window.tc_vars.page_url = window.location.pathname;\n            script.onload = function() {\n              window.setTimeout(function() {\n                if(!window.mdm_events) { return; }\n                var tags = window.mdm_events_pending || [];\n                for(var i=0; i<tags.length; i++) {\n                  if(/(^|;\\s?)debugmdm=/.test(document.cookie)) {\n                    console.log('pending tracking', tags[i]);\n                  }\n                  window.mdm_events(").concat(this.tracking.id, ", tags[i].event, tags[i].data.fn || 'track-event', tags[i].data.data);\n                }\n                window.mdm_events_pending = [];\n              }, 0);\n              window.isTcContainerLoadedBefore = true;\n              if(/(^|;\\s?)debugmdm=/.test(document.cookie)) {\n                console.log('tc_container is loaded');\n              }\n            };\n            script.src = '").concat(this.tracking.container, "?").concat(Math.floor(Date.now() / 1000), "';\n            s.parentNode.insertBefore(script, s);\n          }, { passive: true });"),
        body: true
      };
    },
    safariFix: function safariFix() {
      if (!process.server) {
        return false;
      }
      return {
        innerHTML: '!function(){var e=document,t=e.createElement("script");if(!("noModule"in t)&&"onbeforeload"in t){var n=!1;e.addEventListener("beforeload",function(e){if(e.target===t)n=!0;else if(!e.target.hasAttribute("nomodule")||!n)return;e.preventDefault()},!0),t.type="module",t.src=".",e.head.appendChild(t),t.remove()}}();'
      };
    },
    getAlgoliaUserToken: function getAlgoliaUserToken() {
      var firstInt = Math.floor(Math.random() * 10000000).toString();
      var secondInt = Math.floor(Math.random() * 10000000).toString();
      var userToken = "anonymous-user-".concat(firstInt, "-").concat(secondInt);
      return userToken;
    }
  }),
  watch: {
    $route: function $route(to, from) {
      if (this.notification.message) {
        this.$root.$off('notification-banner');
        this.setNotificationBanner({
          message: '',
          type: ''
        });
      }
    }
  },
  created: function created() {
    var _this = this;
    if (this.$route.name === 'market-language-cart' || this.$route.name === 'market-language-user' || this.$route.name === 'market-language-user-profile') {
      this.ready = false;
    }
    var algoliaUserToken = Boolean(this.$cookies.get('_ALGOLIA'));
    if (!algoliaUserToken) {
      this.$cookies.set('_ALGOLIA', this.getAlgoliaUserToken);
    }
    if ('nothirdparties' in this.$route.query) {
      this.tp = false;
    }
    if (process.client) {
      var _this$$route$query = this.$route.query,
        _this$$route$query$ut = _this$$route$query.utm_source,
        utmSource = _this$$route$query$ut === void 0 ? '' : _this$$route$query$ut,
        _this$$route$query$ut2 = _this$$route$query.utm_medium,
        utmMedium = _this$$route$query$ut2 === void 0 ? '' : _this$$route$query$ut2,
        _this$$route$query$ut3 = _this$$route$query.utm_campaign,
        utmCampaign = _this$$route$query$ut3 === void 0 ? '' : _this$$route$query$ut3,
        _this$$route$query$ut4 = _this$$route$query.utm_content,
        utmContent = _this$$route$query$ut4 === void 0 ? '' : _this$$route$query$ut4,
        _this$$route$query$gc = _this$$route$query.gclid,
        gclid = _this$$route$query$gc === void 0 ? '' : _this$$route$query$gc;
      this.$nextTick(function () {
        var mdmSourceContent;
        if (gclid) mdmSourceContent = "gclid=".concat(gclid);else if (utmSource || utmMedium || utmCampaign || utmContent) mdmSourceContent = "utm_source=".concat(utmSource, "|utm_medium=").concat(utmMedium, "|utm_campaign=").concat(utmCampaign, "|utm_content=").concat(utmContent);
        if (mdmSourceContent) {
          _this.$cookies.set('MDM_SOURCE', mdmSourceContent, {
            path: '/',
            maxAge: 3600 * 24 * 365
          });
        }
      });
    }
    this.$root.$on('updated-tcvars', this.onUpdateTcVars);
    this.$root.$on('updated-payment-methods', this.onUpdatePaymentMethods);
    this.$root.$on('on-tc-hit-blocker', this.onTcHitBlocker);
    this.$root.$on('user-login-success', this.updateUserAndCart);
    this.$root.$on('user-signup-success', this.fetchUser);
    this.$root.$on('notification-banner', this.notificationBannerMessage);
    this.$root.$on('hashCatFirstLevel', this.getHashFirstCat);
  },
  mounted: function mounted() {
    var _this2 = this;
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var isUserLogged;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return refreshTokenIfNecessary({
              app: _this2.$store.app,
              store: _this2.$store
            });
          case 2:
            isUserLogged = _this2.user && _this2.user.id;
            if (isValidToken() && !isUserLogged) {
              _this2.loadUser();
            }
            window.history.scrollRestoration = 'auto';
            window.addEventListener('load', _this2.onLoad, {
              passive: true
            });
            _this2.ready = true;
          case 7:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('load', this.onLoad);
    this.$root.$off('updated-tcvars');
    this.$root.$off('updated-payment-methods');
    this.$root.$off('on-tc-hit-blocker');
    this.$root.$off('generic-tracking');
    this.$root.$off('user-login-success');
    this.$root.$off('user-signup-success');
    this.$root.$off('hashCatFirstLevel');
  },
  methods: _objectSpread(_objectSpread(_objectSpread({}, mapActions({
    fetchUser: 'user/fetchUser',
    fetchWishlist: 'wishlist/fetchWishlistItems',
    fetchCart: 'cart/fetchCart',
    fetchCartTotalQuantity: 'cart/fetchCartTotalQuantity',
    createCart: 'cart/createCart',
    setSellerIdToCart: 'cart/setSellerIdToCart'
  })), mapMutations({
    setNotificationBanner: 'notification/SET_NOTIFICATION_BANNER'
  })), {}, {
    handleRouteOnChange: function handleRouteOnChange(route) {
      if (!this.routesOnNavModifications.includes(route)) {
        this.hashFirstCat = null;
      }
    },
    getHashFirstCat: function getHashFirstCat(hash) {
      if (this.routesOnNavModifications.includes(this.$route.name)) {
        this.hashFirstCat = hash;
      }
    },
    loadUser: function loadUser() {
      var _this3 = this;
      this.fetchUser().then(function () {
        if (_this3.user) {
          window.mdm_user_intercom_hash = _this3.user.intercomHashwindow;
          window.mdm_user_intercom_email = _this3.user.email;
        }
        setTimeout(function () {
          _this3.$root.$emit('reset-tcvars');
        }, FAST_TIMER);
      }).catch(function (err) {
        _this3.$logger.error(err);
      });
    },
    onLoad: function onLoad() {
      var _this4 = this;
      if (process.env.NODE_ENV === 'production') {
        this.abTasty();
      }
      this.fetchCartTotalQuantity().catch(function (err) {
        _this4.$logger.error(err);
      });
      if (isValidToken()) {
        this.fetchWishlist().catch(function (err) {
          _this4.$logger.error(err);
        });
      }
      this.$root.$on('generic-tracking', this.onTracking);
      this.lazyloadComponents();
      if (this.$route.hash) {
        this.connectAs();
      }
    },
    connectAs: function connectAs() {
      var _this5 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _parseHash, token, connectAs, _jwtDecode, sellerId, cartToken;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              // magento return query params behind # instead of ?
              _parseHash = parseHash(_this5.$route.hash.slice(1)), token = _parseHash.drc_token, connectAs = _parseHash.drc_redirect;
              if (!connectAs) {
                _context2.next = 11;
                break;
              }
              _jwtDecode = jwtDecode(token), sellerId = _jwtDecode.seller_id;
              localStorage.setItem('MDM_ACCESS_TOKEN', token);
              if (sellerId) {
                localStorage.setItem('MDM_CONNECT_AS', connectAs);
              }
              _context2.next = 7;
              return _this5.createCart();
            case 7:
              cartToken = _context2.sent;
              _context2.next = 10;
              return _this5.bindSellerIdToCart({
                cartToken: cartToken,
                sellerId: sellerId
              });
            case 10:
              window.location.href = _this5.$route.path;
            case 11:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    bindSellerIdToCart: function bindSellerIdToCart() {
      var _arguments = arguments,
        _this6 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var sellerId;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              sellerId = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : null;
              if (sellerId) {
                _context3.next = 3;
                break;
              }
              return _context3.abrupt("return");
            case 3:
              localStorage.setItem('MDM_CONNECT_AS', true);
              _context3.next = 6;
              return _this6.setSellerIdToCart(sellerId);
            case 6:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    updateUserAndCart: function updateUserAndCart() {
      this.fetchUser();
      this.updateCart();
    },
    updateCart: function updateCart() {
      var _this7 = this;
      this.fetchCart().catch(function (err) {
        _this7.$logger.error(err);
      });
    },
    onUpdateTcVars: function onUpdateTcVars(tcVars) {
      this.tcVars = tcVars;
      if (process.client && Object.keys(this.tcVars).length) {
        if (this.$cookies.get('debugmdm')) {
          console.log('inject Tcvars', _objectSpread({}, this.tcVars));
        }
        window.tc_vars = _objectSpread({}, this.tcVars);
        if (window.tC) {
          window.tC.container.reload();
          window.tC.event.reload();
          if (this.$cookies.get('debugmdm')) {
            console.log('container.reload() and event.reload()');
          }
        }
      }
    },
    onUpdatePaymentMethods: function onUpdatePaymentMethods(paymentMethods) {
      window.tc_vars = _objectSpread(_objectSpread({}, window.tc_vars), {}, {
        paymentMethods: paymentMethods
      });
    },
    onTcHitBlocker: function onTcHitBlocker(tcVars) {
      this.tcVars = tcVars;
      window.tc_vars = _objectSpread({}, this.tcVars);
      if (this.$cookies.get('debugmdm')) {
        console.log('onTcHitBlocker:', _objectSpread({}, window.tc_vars));
      }
    },
    onTracking: function onTracking(el, payload) {
      trackEvent({
        el: el,
        payload: payload,
        id: this.tracking.id,
        isCookieDebug: this.$nuxt.$cookies.get('debugmdm')
      });
    },
    abTasty: function abTasty() {
      var _this8 = this;
      if (this.tp === false) {
        return;
      }
      this.asyncScript(ABTASTY_URL).catch(function (err) {
        _this8.$logger.error('ABTASTY FAILED', err);
      });
    },
    notificationBannerMessage: function notificationBannerMessage(_ref) {
      var message = _ref.message,
        type = _ref.type;
      this.setNotificationBanner({
        message: message,
        type: type
      });
    },
    lazyloadComponents: function lazyloadComponents() {
      this.mdmLayer = MdmLayer;
    }
  })
};